import * as React from "react";
import "./ContainerWrapper.scss";

interface IContainerWrapperProp {
    style?: React.CSSProperties;
    className?: string;
}
export class ContainerWrapper extends React.Component<IContainerWrapperProp> {

    public render() {
        const style = {
            maxWidth: "1160px",
            height: "100%",
            margin: "auto",
            ...this.props.style
        };
        return (
            <div className={`container-wrapper ${this.props.className ? this.props.className : ""}`} style={style}>
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/ContainerWrapper/ContainerWrapper.tsx